import { default as aboutuGaiEcmD8pMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsJcxyPlflUkMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93wFM8ceGW2bMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample0sAilS7xMGMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsULP4J7t2oHMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93pGFS3nBewrMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewUfn9sPWGrIMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexRbdUcTU5OmMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ha6CVu33znMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexrkZl9WoR45Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93rHffBw1vPHMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexLfytliDe0wMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsTfd5p6jdYeMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsb2DC7xTKDPMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsG21iKt2cP1Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93G27V6qCTmXMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as index392ddhkRdTMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmkpM30tfNFUMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmPB0ZZaP8jIMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarEtU22RHw1CMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/calendar.vue?macro=true";
import { default as chat8I3Xz8rOt1Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/chat.vue?macro=true";
import { default as abouty0pXZrbyuUMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedBxCxzDG2gbMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersO76l8EnozxMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_934rVBvrckUaMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editJfz6sp4mVSMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_937hyhDqbil4Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communitylyIRF6DXnNMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93g36XHNgtC4Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93nKMZgBtfU9Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardZ4nC8DRPkFMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indextXx99PdfXNMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutm5SAWcwtiMMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45product4X085DLpFZMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsc4OCaPyAt8Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93Tu3mDGfUERMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexD5NbANyuf9Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93lCfE7k11OrMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93ufdLAEiIdtMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as index14dq4wJtLuMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93ROYypSw4GJMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinZooaPvKlZuMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/join.vue?macro=true";
import { default as loginIkvwlNSSgsMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/login.vue?macro=true";
import { default as logoutiicKpEpPvtMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_932AK53L6numMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93vcQ57ijJLvMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_936ZO8V5UMpyMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritespYt99zj1ypMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios39g3kJKHd7Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optin5tRjj11QsbMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93UjHPdDdeeNMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexBuUOABApXQMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexZtGwuhK3hmMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutDmvwPHlR3IMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentcinz4YDvMMMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as events7fjNqVFioeMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93Tz5OidsPGjMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample1e5DFavaHCMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsapinEVkYQbMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93TmwM7zwSUNMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewHgeYs77IInMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexi3ombQAvmVMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93hli4w0aahqMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index5Tv2u1ezVAMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93HBHDIpgp7LMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexRPwRX295b5Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsuiVXFueIYLMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsmqPcORjTDZMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsVskOJD35QBMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93AxxCnsPsv7Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexTlIhLrX1X2Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexb4Cr8Qb8BXMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchaseszm9WsWbtLxMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsotmPQzPcXxMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_932KylfmYYOjMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93I6xWNSQj6eMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetFiVVZuXK0EMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/reset.vue?macro=true";
import { default as shopsOiFn1MXE4Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/shop.vue?macro=true";
import { default as signupRvqt0tE2wyMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/signup.vue?macro=true";
import { default as liveIXUpQ0UZjIMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tips3TWNkugObwMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93XZh58ioqsGMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactEGUibaPBT0Meta } from "/tmp/build_ad3e8925/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullAYu3MP6dFMMeta } from "/tmp/build_ad3e8925/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93G27V6qCTmXMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93G27V6qCTmXMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93G27V6qCTmXMeta || {},
    alias: _91product_id_93G27V6qCTmXMeta?.alias || [],
    redirect: _91product_id_93G27V6qCTmXMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutuGaiEcmD8pMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutuGaiEcmD8pMeta?.path ?? "about",
    meta: aboutuGaiEcmD8pMeta || {},
    alias: aboutuGaiEcmD8pMeta?.alias || [],
    redirect: aboutuGaiEcmD8pMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsJcxyPlflUkMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsJcxyPlflUkMeta?.path ?? "events",
    meta: eventsJcxyPlflUkMeta || {},
    alias: eventsJcxyPlflUkMeta?.alias || [],
    redirect: eventsJcxyPlflUkMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wFM8ceGW2bMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93wFM8ceGW2bMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93wFM8ceGW2bMeta || {},
    alias: _91media_id_93wFM8ceGW2bMeta?.alias || [],
    redirect: _91media_id_93wFM8ceGW2bMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample0sAilS7xMGMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sample0sAilS7xMGMeta?.path ?? "free-sample",
    meta: free_45sample0sAilS7xMGMeta || {},
    alias: free_45sample0sAilS7xMGMeta?.alias || [],
    redirect: free_45sample0sAilS7xMGMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsULP4J7t2oHMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsULP4J7t2oHMeta?.path ?? "included-products",
    meta: included_45productsULP4J7t2oHMeta || {},
    alias: included_45productsULP4J7t2oHMeta?.alias || [],
    redirect: included_45productsULP4J7t2oHMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93pGFS3nBewrMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93pGFS3nBewrMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93pGFS3nBewrMeta || {},
    alias: _91media_id_93pGFS3nBewrMeta?.alias || [],
    redirect: _91media_id_93pGFS3nBewrMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewUfn9sPWGrIMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewUfn9sPWGrIMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewUfn9sPWGrIMeta || {},
    alias: viewUfn9sPWGrIMeta?.alias || [],
    redirect: viewUfn9sPWGrIMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexRbdUcTU5OmMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexRbdUcTU5OmMeta?.path ?? "lessons",
    meta: indexRbdUcTU5OmMeta || {},
    alias: indexRbdUcTU5OmMeta?.alias || [],
    redirect: indexRbdUcTU5OmMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ha6CVu33znMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93ha6CVu33znMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93ha6CVu33znMeta || {},
    alias: _91media_id_93ha6CVu33znMeta?.alias || [],
    redirect: _91media_id_93ha6CVu33znMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexrkZl9WoR45Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexrkZl9WoR45Meta?.path ?? "playlists/:playlist_id()",
    meta: indexrkZl9WoR45Meta || {},
    alias: indexrkZl9WoR45Meta?.alias || [],
    redirect: indexrkZl9WoR45Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93rHffBw1vPHMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93rHffBw1vPHMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93rHffBw1vPHMeta || {},
    alias: _91media_id_93rHffBw1vPHMeta?.alias || [],
    redirect: _91media_id_93rHffBw1vPHMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexLfytliDe0wMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexLfytliDe0wMeta?.path ?? "playlists",
    meta: indexLfytliDe0wMeta || {},
    alias: indexLfytliDe0wMeta?.alias || [],
    redirect: indexLfytliDe0wMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsTfd5p6jdYeMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsTfd5p6jdYeMeta?.path ?? "private-sessions",
    meta: private_45sessionsTfd5p6jdYeMeta || {},
    alias: private_45sessionsTfd5p6jdYeMeta?.alias || [],
    redirect: private_45sessionsTfd5p6jdYeMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsb2DC7xTKDPMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsb2DC7xTKDPMeta?.path ?? "recordings",
    meta: recordingsb2DC7xTKDPMeta || {},
    alias: recordingsb2DC7xTKDPMeta?.alias || [],
    redirect: recordingsb2DC7xTKDPMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsG21iKt2cP1Meta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsG21iKt2cP1Meta?.path ?? "reviews",
    meta: reviewsG21iKt2cP1Meta || {},
    alias: reviewsG21iKt2cP1Meta?.alias || [],
    redirect: reviewsG21iKt2cP1Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index392ddhkRdTMeta?.name ?? "buy-product-product_id",
    path: index392ddhkRdTMeta?.path ?? "/buy/product/:product_id()",
    meta: index392ddhkRdTMeta || {},
    alias: index392ddhkRdTMeta?.alias || [],
    redirect: index392ddhkRdTMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmkpM30tfNFUMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmkpM30tfNFUMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmkpM30tfNFUMeta || {},
    alias: confirmkpM30tfNFUMeta?.alias || [],
    redirect: confirmkpM30tfNFUMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmPB0ZZaP8jIMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmPB0ZZaP8jIMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmPB0ZZaP8jIMeta || {},
    alias: confirmPB0ZZaP8jIMeta?.alias || [],
    redirect: confirmPB0ZZaP8jIMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarEtU22RHw1CMeta?.name ?? "calendar",
    path: calendarEtU22RHw1CMeta?.path ?? "/calendar",
    meta: calendarEtU22RHw1CMeta || {},
    alias: calendarEtU22RHw1CMeta?.alias || [],
    redirect: calendarEtU22RHw1CMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chat8I3Xz8rOt1Meta?.name ?? "chat",
    path: chat8I3Xz8rOt1Meta?.path ?? "/chat",
    meta: chat8I3Xz8rOt1Meta || {},
    alias: chat8I3Xz8rOt1Meta?.alias || [],
    redirect: chat8I3Xz8rOt1Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_934rVBvrckUaMeta?.name ?? "community-groups-group_id",
    path: _91group_id_934rVBvrckUaMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_934rVBvrckUaMeta || {},
    alias: _91group_id_934rVBvrckUaMeta?.alias || [],
    redirect: _91group_id_934rVBvrckUaMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouty0pXZrbyuUMeta?.name ?? "community-groups-group_id-about",
    path: abouty0pXZrbyuUMeta?.path ?? "about",
    meta: abouty0pXZrbyuUMeta || {},
    alias: abouty0pXZrbyuUMeta?.alias || [],
    redirect: abouty0pXZrbyuUMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedBxCxzDG2gbMeta?.name ?? "community-groups-group_id-feed",
    path: feedBxCxzDG2gbMeta?.path ?? "feed",
    meta: feedBxCxzDG2gbMeta || {},
    alias: feedBxCxzDG2gbMeta?.alias || [],
    redirect: feedBxCxzDG2gbMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersO76l8EnozxMeta?.name ?? "community-groups-group_id-members",
    path: membersO76l8EnozxMeta?.path ?? "members",
    meta: membersO76l8EnozxMeta || {},
    alias: membersO76l8EnozxMeta?.alias || [],
    redirect: membersO76l8EnozxMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editJfz6sp4mVSMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editJfz6sp4mVSMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editJfz6sp4mVSMeta || {},
    alias: community_45profile_45editJfz6sp4mVSMeta?.alias || [],
    redirect: community_45profile_45editJfz6sp4mVSMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_937hyhDqbil4Meta?.name ?? "community-profile-id",
    path: _91id_937hyhDqbil4Meta?.path ?? "/community-profile/:id()",
    meta: _91id_937hyhDqbil4Meta || {},
    alias: _91id_937hyhDqbil4Meta?.alias || [],
    redirect: _91id_937hyhDqbil4Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communitylyIRF6DXnNMeta?.name ?? "community",
    path: communitylyIRF6DXnNMeta?.path ?? "/community",
    meta: communitylyIRF6DXnNMeta || {},
    alias: communitylyIRF6DXnNMeta?.alias || [],
    redirect: communitylyIRF6DXnNMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93g36XHNgtC4Meta?.name ?? "complete-registration-uuid",
    path: _91uuid_93g36XHNgtC4Meta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93g36XHNgtC4Meta || {},
    alias: _91uuid_93g36XHNgtC4Meta?.alias || [],
    redirect: _91uuid_93g36XHNgtC4Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93nKMZgBtfU9Meta?.name ?? "contracts-unique_id",
    path: _91unique_id_93nKMZgBtfU9Meta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93nKMZgBtfU9Meta || {},
    alias: _91unique_id_93nKMZgBtfU9Meta?.alias || [],
    redirect: _91unique_id_93nKMZgBtfU9Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardZ4nC8DRPkFMeta?.name ?? "dashboard",
    path: dashboardZ4nC8DRPkFMeta?.path ?? "/dashboard",
    meta: dashboardZ4nC8DRPkFMeta || {},
    alias: dashboardZ4nC8DRPkFMeta?.alias || [],
    redirect: dashboardZ4nC8DRPkFMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indextXx99PdfXNMeta?.name ?? "event-details-event_id",
    path: indextXx99PdfXNMeta?.path ?? "/event/details/:event_id()",
    meta: indextXx99PdfXNMeta || {},
    alias: indextXx99PdfXNMeta?.alias || [],
    redirect: indextXx99PdfXNMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutm5SAWcwtiMMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutm5SAWcwtiMMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutm5SAWcwtiMMeta || {},
    alias: checkoutm5SAWcwtiMMeta?.alias || [],
    redirect: checkoutm5SAWcwtiMMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45product4X085DLpFZMeta?.name ?? "event-details-event_id-select-product",
    path: select_45product4X085DLpFZMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45product4X085DLpFZMeta || {},
    alias: select_45product4X085DLpFZMeta?.alias || [],
    redirect: select_45product4X085DLpFZMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsc4OCaPyAt8Meta?.name ?? "events",
    path: eventsc4OCaPyAt8Meta?.path ?? "/events",
    meta: eventsc4OCaPyAt8Meta || {},
    alias: eventsc4OCaPyAt8Meta?.alias || [],
    redirect: eventsc4OCaPyAt8Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93Tu3mDGfUERMeta?.name ?? "gifts-uuid",
    path: _91uuid_93Tu3mDGfUERMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93Tu3mDGfUERMeta || {},
    alias: _91uuid_93Tu3mDGfUERMeta?.alias || [],
    redirect: _91uuid_93Tu3mDGfUERMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexD5NbANyuf9Meta?.name ?? "gifts",
    path: indexD5NbANyuf9Meta?.path ?? "/gifts",
    meta: indexD5NbANyuf9Meta || {},
    alias: indexD5NbANyuf9Meta?.alias || [],
    redirect: indexD5NbANyuf9Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93lCfE7k11OrMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93lCfE7k11OrMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93lCfE7k11OrMeta || {},
    alias: _91invitation_id_93lCfE7k11OrMeta?.alias || [],
    redirect: _91invitation_id_93lCfE7k11OrMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93ufdLAEiIdtMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93ufdLAEiIdtMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93ufdLAEiIdtMeta || {},
    alias: _91product_id_93ufdLAEiIdtMeta?.alias || [],
    redirect: _91product_id_93ufdLAEiIdtMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: index14dq4wJtLuMeta?.name ?? "index",
    path: index14dq4wJtLuMeta?.path ?? "/",
    meta: index14dq4wJtLuMeta || {},
    alias: index14dq4wJtLuMeta?.alias || [],
    redirect: index14dq4wJtLuMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93ROYypSw4GJMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93ROYypSw4GJMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93ROYypSw4GJMeta || {},
    alias: _91invitation_unique_id_93ROYypSw4GJMeta?.alias || [],
    redirect: _91invitation_unique_id_93ROYypSw4GJMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinZooaPvKlZuMeta?.name ?? "join",
    path: joinZooaPvKlZuMeta?.path ?? "/join",
    meta: joinZooaPvKlZuMeta || {},
    alias: joinZooaPvKlZuMeta?.alias || [],
    redirect: joinZooaPvKlZuMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginIkvwlNSSgsMeta?.name ?? "login",
    path: loginIkvwlNSSgsMeta?.path ?? "/login",
    meta: loginIkvwlNSSgsMeta || {},
    alias: loginIkvwlNSSgsMeta?.alias || [],
    redirect: loginIkvwlNSSgsMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutiicKpEpPvtMeta?.name ?? "logout",
    path: logoutiicKpEpPvtMeta?.path ?? "/logout",
    meta: logoutiicKpEpPvtMeta || {},
    alias: logoutiicKpEpPvtMeta?.alias || [],
    redirect: logoutiicKpEpPvtMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_932AK53L6numMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_932AK53L6numMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_932AK53L6numMeta || {},
    alias: _91meeting_type_slug_932AK53L6numMeta?.alias || [],
    redirect: _91meeting_type_slug_932AK53L6numMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93vcQ57ijJLvMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93vcQ57ijJLvMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93vcQ57ijJLvMeta || {},
    alias: _91meeting_unique_id_93vcQ57ijJLvMeta?.alias || [],
    redirect: _91meeting_unique_id_93vcQ57ijJLvMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_936ZO8V5UMpyMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_936ZO8V5UMpyMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_936ZO8V5UMpyMeta || {},
    alias: _91meeting_unique_id_936ZO8V5UMpyMeta?.alias || [],
    redirect: _91meeting_unique_id_936ZO8V5UMpyMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritespYt99zj1ypMeta?.name ?? "my-favorites",
    path: my_45favoritespYt99zj1ypMeta?.path ?? "/my-favorites",
    meta: my_45favoritespYt99zj1ypMeta || {},
    alias: my_45favoritespYt99zj1ypMeta?.alias || [],
    redirect: my_45favoritespYt99zj1ypMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios39g3kJKHd7Meta?.name ?? "my-studios",
    path: my_45studios39g3kJKHd7Meta?.path ?? "/my-studios",
    meta: my_45studios39g3kJKHd7Meta || {},
    alias: my_45studios39g3kJKHd7Meta?.alias || [],
    redirect: my_45studios39g3kJKHd7Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optin5tRjj11QsbMeta?.name ?? "optin",
    path: optin5tRjj11QsbMeta?.path ?? "/optin",
    meta: optin5tRjj11QsbMeta || {},
    alias: optin5tRjj11QsbMeta?.alias || [],
    redirect: optin5tRjj11QsbMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93UjHPdDdeeNMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93UjHPdDdeeNMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93UjHPdDdeeNMeta || {},
    alias: _91episode_id_93UjHPdDdeeNMeta?.alias || [],
    redirect: _91episode_id_93UjHPdDdeeNMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexBuUOABApXQMeta?.name ?? "podcasts-podcast_id",
    path: indexBuUOABApXQMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexBuUOABApXQMeta || {},
    alias: indexBuUOABApXQMeta?.alias || [],
    redirect: indexBuUOABApXQMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZtGwuhK3hmMeta?.name ?? "podcasts",
    path: indexZtGwuhK3hmMeta?.path ?? "/podcasts",
    meta: indexZtGwuhK3hmMeta || {},
    alias: indexZtGwuhK3hmMeta?.alias || [],
    redirect: indexZtGwuhK3hmMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93AxxCnsPsv7Meta?.name ?? "product-product_id",
    path: _91product_id_93AxxCnsPsv7Meta?.path ?? "/product/:product_id()",
    meta: _91product_id_93AxxCnsPsv7Meta || {},
    alias: _91product_id_93AxxCnsPsv7Meta?.alias || [],
    redirect: _91product_id_93AxxCnsPsv7Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutDmvwPHlR3IMeta?.name ?? "product-product_id-about",
    path: aboutDmvwPHlR3IMeta?.path ?? "about",
    meta: aboutDmvwPHlR3IMeta || {},
    alias: aboutDmvwPHlR3IMeta?.alias || [],
    redirect: aboutDmvwPHlR3IMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentcinz4YDvMMMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentcinz4YDvMMMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentcinz4YDvMMMeta || {},
    alias: digital_45download_45contentcinz4YDvMMMeta?.alias || [],
    redirect: digital_45download_45contentcinz4YDvMMMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: events7fjNqVFioeMeta?.name ?? "product-product_id-events",
    path: events7fjNqVFioeMeta?.path ?? "events",
    meta: events7fjNqVFioeMeta || {},
    alias: events7fjNqVFioeMeta?.alias || [],
    redirect: events7fjNqVFioeMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Tz5OidsPGjMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93Tz5OidsPGjMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93Tz5OidsPGjMeta || {},
    alias: _91media_id_93Tz5OidsPGjMeta?.alias || [],
    redirect: _91media_id_93Tz5OidsPGjMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample1e5DFavaHCMeta?.name ?? "product-product_id-free-sample",
    path: free_45sample1e5DFavaHCMeta?.path ?? "free-sample",
    meta: free_45sample1e5DFavaHCMeta || {},
    alias: free_45sample1e5DFavaHCMeta?.alias || [],
    redirect: free_45sample1e5DFavaHCMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsapinEVkYQbMeta?.name ?? "product-product_id-included-products",
    path: included_45productsapinEVkYQbMeta?.path ?? "included-products",
    meta: included_45productsapinEVkYQbMeta || {},
    alias: included_45productsapinEVkYQbMeta?.alias || [],
    redirect: included_45productsapinEVkYQbMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93TmwM7zwSUNMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93TmwM7zwSUNMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93TmwM7zwSUNMeta || {},
    alias: _91media_id_93TmwM7zwSUNMeta?.alias || [],
    redirect: _91media_id_93TmwM7zwSUNMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewHgeYs77IInMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewHgeYs77IInMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewHgeYs77IInMeta || {},
    alias: viewHgeYs77IInMeta?.alias || [],
    redirect: viewHgeYs77IInMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexi3ombQAvmVMeta?.name ?? "product-product_id-lessons",
    path: indexi3ombQAvmVMeta?.path ?? "lessons",
    meta: indexi3ombQAvmVMeta || {},
    alias: indexi3ombQAvmVMeta?.alias || [],
    redirect: indexi3ombQAvmVMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93hli4w0aahqMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93hli4w0aahqMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93hli4w0aahqMeta || {},
    alias: _91media_id_93hli4w0aahqMeta?.alias || [],
    redirect: _91media_id_93hli4w0aahqMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index5Tv2u1ezVAMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: index5Tv2u1ezVAMeta?.path ?? "playlists/:playlist_id()",
    meta: index5Tv2u1ezVAMeta || {},
    alias: index5Tv2u1ezVAMeta?.alias || [],
    redirect: index5Tv2u1ezVAMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93HBHDIpgp7LMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93HBHDIpgp7LMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93HBHDIpgp7LMeta || {},
    alias: _91media_id_93HBHDIpgp7LMeta?.alias || [],
    redirect: _91media_id_93HBHDIpgp7LMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexRPwRX295b5Meta?.name ?? "product-product_id-playlists",
    path: indexRPwRX295b5Meta?.path ?? "playlists",
    meta: indexRPwRX295b5Meta || {},
    alias: indexRPwRX295b5Meta?.alias || [],
    redirect: indexRPwRX295b5Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsuiVXFueIYLMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsuiVXFueIYLMeta?.path ?? "private-sessions",
    meta: private_45sessionsuiVXFueIYLMeta || {},
    alias: private_45sessionsuiVXFueIYLMeta?.alias || [],
    redirect: private_45sessionsuiVXFueIYLMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsmqPcORjTDZMeta?.name ?? "product-product_id-recordings",
    path: recordingsmqPcORjTDZMeta?.path ?? "recordings",
    meta: recordingsmqPcORjTDZMeta || {},
    alias: recordingsmqPcORjTDZMeta?.alias || [],
    redirect: recordingsmqPcORjTDZMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsVskOJD35QBMeta?.name ?? "product-product_id-reviews",
    path: reviewsVskOJD35QBMeta?.path ?? "reviews",
    meta: reviewsVskOJD35QBMeta || {},
    alias: reviewsVskOJD35QBMeta?.alias || [],
    redirect: reviewsVskOJD35QBMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexTlIhLrX1X2Meta?.name ?? "product",
    path: indexTlIhLrX1X2Meta?.path ?? "/product",
    meta: indexTlIhLrX1X2Meta || {},
    alias: indexTlIhLrX1X2Meta?.alias || [],
    redirect: indexTlIhLrX1X2Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexb4Cr8Qb8BXMeta?.name ?? "profile",
    path: indexb4Cr8Qb8BXMeta?.path ?? "/profile",
    meta: indexb4Cr8Qb8BXMeta || {},
    alias: indexb4Cr8Qb8BXMeta?.alias || [],
    redirect: indexb4Cr8Qb8BXMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchaseszm9WsWbtLxMeta?.name ?? "profile-purchases",
    path: purchaseszm9WsWbtLxMeta?.path ?? "/profile/purchases",
    meta: purchaseszm9WsWbtLxMeta || {},
    alias: purchaseszm9WsWbtLxMeta?.alias || [],
    redirect: purchaseszm9WsWbtLxMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsotmPQzPcXxMeta?.name ?? "profile-redemptions",
    path: redemptionsotmPQzPcXxMeta?.path ?? "/profile/redemptions",
    meta: redemptionsotmPQzPcXxMeta || {},
    alias: redemptionsotmPQzPcXxMeta?.alias || [],
    redirect: redemptionsotmPQzPcXxMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_932KylfmYYOjMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_932KylfmYYOjMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_932KylfmYYOjMeta || {},
    alias: _91quiz_id_932KylfmYYOjMeta?.alias || [],
    redirect: _91quiz_id_932KylfmYYOjMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93I6xWNSQj6eMeta?.name ?? "reset-password-uid-token",
    path: _91token_93I6xWNSQj6eMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93I6xWNSQj6eMeta || {},
    alias: _91token_93I6xWNSQj6eMeta?.alias || [],
    redirect: _91token_93I6xWNSQj6eMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetFiVVZuXK0EMeta?.name ?? "reset",
    path: resetFiVVZuXK0EMeta?.path ?? "/reset",
    meta: resetFiVVZuXK0EMeta || {},
    alias: resetFiVVZuXK0EMeta?.alias || [],
    redirect: resetFiVVZuXK0EMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopsOiFn1MXE4Meta?.name ?? "shop",
    path: shopsOiFn1MXE4Meta?.path ?? "/shop",
    meta: shopsOiFn1MXE4Meta || {},
    alias: shopsOiFn1MXE4Meta?.alias || [],
    redirect: shopsOiFn1MXE4Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupRvqt0tE2wyMeta?.name ?? "signup",
    path: signupRvqt0tE2wyMeta?.path ?? "/signup",
    meta: signupRvqt0tE2wyMeta || {},
    alias: signupRvqt0tE2wyMeta?.alias || [],
    redirect: signupRvqt0tE2wyMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveIXUpQ0UZjIMeta?.name ?? "streaming-event_id-live",
    path: liveIXUpQ0UZjIMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveIXUpQ0UZjIMeta || {},
    alias: liveIXUpQ0UZjIMeta?.alias || [],
    redirect: liveIXUpQ0UZjIMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tips3TWNkugObwMeta?.name ?? "tips",
    path: tips3TWNkugObwMeta?.path ?? "/tips",
    meta: tips3TWNkugObwMeta || {},
    alias: tips3TWNkugObwMeta?.alias || [],
    redirect: tips3TWNkugObwMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93XZh58ioqsGMeta?.name ?? "waiver-uuid",
    path: _91uuid_93XZh58ioqsGMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93XZh58ioqsGMeta || {},
    alias: _91uuid_93XZh58ioqsGMeta?.alias || [],
    redirect: _91uuid_93XZh58ioqsGMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactEGUibaPBT0Meta?.name ?? "widgets-calendars-compact",
    path: compactEGUibaPBT0Meta?.path ?? "/widgets/calendars/compact",
    meta: compactEGUibaPBT0Meta || {},
    alias: compactEGUibaPBT0Meta?.alias || [],
    redirect: compactEGUibaPBT0Meta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullAYu3MP6dFMMeta?.name ?? "widgets-calendars-full",
    path: fullAYu3MP6dFMMeta?.path ?? "/widgets/calendars/full",
    meta: fullAYu3MP6dFMMeta || {},
    alias: fullAYu3MP6dFMMeta?.alias || [],
    redirect: fullAYu3MP6dFMMeta?.redirect,
    component: () => import("/tmp/build_ad3e8925/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]